<template>
	<div class="w-full h-fit rounded-xl border border-neutral-subtle bg-neutral p-8 card-shadow">
		<span class="text-xl font-bold text-heading">{{ category.name }}</span>

		<div class="w-full mt-3">
			<div class="flex flex-col space-y-3 w-full">
				<div v-for="subcategory in subcategories" :key="subcategory.id" class="flex flex-col">
					<div class="flex cursor-pointer items-center" @click.prevent="toggleCategory(subcategory.id)">
						<span class="flex-grow font-semibold leading-6 text-label">{{ subcategory.name }}</span>
						<img v-if="expandedCategories.has(subcategory.id)" src="@/assets/images/icon/minus.svg" alt="-" title="Collapse">
						<img v-else src="@/assets/images/icon/plus.svg" alt="+" title="Expand">
					</div>

					<div v-if="expandedCategories.has(subcategory.id)" class="flex flex-col mt-2 space-y-2">
						<div v-for="resource in subcategory.resources" :key="resource.url" class="flex space-x-2">
							<div class="size-4.5 mt-1">
								<svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
									<path d="M5.82148 16.1156C5.65273 16.1156 5.51211 16.0594 5.37148 15.9469C5.11836 15.6938 5.11836 15.3 5.37148 15.0469L11.2777 9.00001L5.37148 2.98126C5.11836 2.72814 5.11836 2.33439 5.37148 2.08126C5.62461 1.82814 6.01836 1.82814 6.27148 2.08126L12.6277 8.55001C12.8809 8.80314 12.8809 9.19689 12.6277 9.45001L6.27148 15.9188C6.15898 16.0313 5.99023 16.1156 5.82148 16.1156Z" fill="#FF5100"/>
								</svg>
							</div>
							<a :href="resource.url" class="flex clickable-text items-center" target="_blank">{{ resource.name }}</a>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script setup lang="js">

import { ref } from 'vue'

const props = defineProps(
	{
		category: { type: Object, default: null },
		disabled: { type: Boolean, default: false },
	})

const emit = defineEmits(['categoryExpanded'])
const subcategories = props.category.subcategories.filter((subcategory) => {
	return subcategory.resources.length > 0
})

let expandedCategories = ref(new Set())

function toggleCategory(categoryId)
{
	if (props.disabled) {return;}
	if (expandedCategories.value.has(categoryId))
	{
		expandedCategories.value.delete(categoryId)
	}
	else
	{
		expandedCategories.value.add(categoryId)
	}

	expandedCategories.value = new Set(expandedCategories.value)

	if (expandedCategories.value.has(categoryId))
	{
		emit('categoryExpanded')
	}
}

</script>

<style scoped>

.card-shadow {
	box-shadow: 0 8px 13px -3px rgba(0, 0, 0, 0.07);
}

</style>
